// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2Rojh","sendOtp":"AuthorizeToLogin_sendOtp__4BnVs"};